const BarsIcon = (props) => {
    return (
        <svg
            width={30}
            height={30}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M25.848 9.757H4.05a.879.879 0 110-1.758h21.797a.88.88 0 010 1.758zM25.848 16.39H4.05a.879.879 0 010-1.758h21.797a.88.88 0 010 1.758zM25.848 23.023H4.05a.879.879 0 010-1.758h21.797a.879.879 0 010 1.758z"
                fill="#6E0202"
            />
        </svg>
    )
}

export default BarsIcon